import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiRequest from '../../../../utils/apiRequest';
import { MAIN_POST, IMAGE_ADDRESS } from '../../../../apis';
import { handleChangeDataPageMain } from '../../../../redux/actions/pages/main';
import { useEffect } from 'react';
import CardAdsBannerFourImg from './cards/cardAdsBannerFourImg';
import CardAdsBannerTwoImg from './cards/cardAdsBannerTwoImg';

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {Navigation, Pagination, EffectFade, Autoplay, Scrollbar, A11y} from 'swiper/modules';
import { Link, useNavigate } from 'react-router-dom';
import { LazyLoadImage } from "react-lazy-load-image-component";
import CardStory from './cardStory';
import Amazings from '../../../../styles/images/svg/specialCarousel/Amazings.svg';
import Amazing from '../../../../styles/images/svg/specialCarousel/Amazing.svg';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";




const MainBody = () => {

	const dispatch = useDispatch();
    const navigate = useNavigate();

	const { token } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { categories } = useSelector(state => state.categories);
	const { mainSlider, adsFourImages, adsTwoImages, tasteful1, tasteful2, bestSelling, hotSales, featuredDiscounts, amazingOffers, stories, sellers } = useSelector(state => state.main);

	useEffect(() => {
        apiMain();
    }, [MainBody]);


	// State to manage countdown timers for each campaign
  	const [timers, setTimers] = useState({});
  	useEffect(() => {
        // Initialize timers for each campaign
        const initialTimers = amazingOffers.reduce((acc, campaign, index) => {
            acc[index] = {
                hours: campaign.remainingTime.hours || 0,
                minutes: campaign.remainingTime.minutes || 0,
                seconds: campaign.remainingTime.seconds || 0,
            };
          return acc;
        }, {});

        setTimers(initialTimers);

        // Set up interval to update timers every second
        const interval = setInterval(() => {
            setTimers((prevTimers) => {
                const updatedTimers = { ...prevTimers };

                Object.keys(updatedTimers).forEach((index) => {
                    let { hours, minutes, seconds } = updatedTimers[index];

                    // Decrease seconds
                    seconds -= 1;

                    // Handle negative seconds
                    if (seconds < 0) {
                        seconds = 59;
                        minutes -= 1;
                    }

                    // Handle negative minutes
                    if (minutes < 0) {
                        minutes = 59;
                        hours -= 1;
                    }

                    // If time is up, set to zero
                    if (hours < 0) {
                        hours = 0;
                        minutes = 0;
                        seconds = 0;
                    }

                    updatedTimers[index] = { hours, minutes, seconds };
                });

                return updatedTimers;
            });
        }, 1000); // Update every 1000ms (1 second)

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, [amazingOffers]);




    const apiMain = () => {
    	if(! isBackdropLoading) {
    		apiRequest({
			    dispatch,
			    endpoint: (MAIN_POST),
			    data: {width: window.innerWidth},
			    method: 'post',
			    token: token,
			    onSuccess: (res) => {
			    	dispatch(handleChangeDataPageMain('mainSlider', res.mainSlider));
			    	dispatch(handleChangeDataPageMain('adsTwoImages', res.adsTwoImages));
			    	dispatch(handleChangeDataPageMain('adsFourImages', res.adsFourImages));
			    	dispatch(handleChangeDataPageMain('tasteful1', res.tasteful1));
			    	dispatch(handleChangeDataPageMain('tasteful2', res.tasteful2));
			    	dispatch(handleChangeDataPageMain('bestSelling', res.bestSelling));
			    	dispatch(handleChangeDataPageMain('hotSales', res.hotSales));
			    	dispatch(handleChangeDataPageMain('featuredDiscounts', res.featuredDiscounts));
			    	dispatch(handleChangeDataPageMain('amazingOffers', res.amazingOffers));
                    dispatch(handleChangeDataPageMain('stories', res.stories));
                    dispatch(handleChangeDataPageMain('sellers', res.sellers));
			    },
		  	});
    	}
    };


	const story_swiper = {
        slidesPerView: 5,
        spaceBetween: 0,
        direction:'horizontal',
        className:"swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-rtl",
        // nested: true,
        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            340: {
                slidesPerView: 3.4,
            },
            360: {
                slidesPerView: 3.8,
            },
            385: {
                slidesPerView: 4.3,
            },
            400: {
                slidesPerView: 4.7,
            },
            500: {
                slidesPerView: 12.4,
            }
        }
    }




    const buyByCategoriesSwiper = {
    	slidesPerView: 3.5,
        spaceBetween: 0,
        direction:'horizontal',
        className:"swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl",
        // nested: true,
        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            700: {
                slidesPerView: 4.5,
            },
            850: {
                slidesPerView: 5.5,
            },
            1024: {
                slidesPerView: 6.5,
            },
            1200: {
                slidesPerView: 7.5,
            },
            1720: {
                slidesPerView: 9.5,
            }
        }
    }


    // const brands = [
    // 	{image: Brand1, title: 'پریل'},
    // 	{image: Brand2, title: 'پرسیل'},
    // 	{image: Brand3, title: 'چرم مشهد'},
    // 	{image: Brand4, title: 'هوآوی'},
    // 	{image: Brand5, title: 'چینی زرین ایران'},
    // 	{image: Brand6, title: 'پنتر'},
    // 	{image: Brand7, title: 'ایکس ویژن'},
    // 	{image: Brand8, title: 'پمینا'},
    // 	{image: Brand9, title: 'یوروویتال'},
    // 	{image: Brand10, title: 'لافارر'},
    // 	{image: Brand11, title: 'اکتیو'},
    // 	{image: Brand12, title: 'سامسونگ'},
    // 	{image: Brand13, title: 'شیائومی'},
    // 	{image: Brand14, title: 'کاله'},
    // 	{image: Brand15, title: 'مای'},
    // ]



    
    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };


    return (

    	<div className="flex flex-col gap-y-4">
			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="container-2xl-w mx-auto">
					<div className="pt-4">
						<Swiper className="hideNextPrev" {...story_swiper}>
                        {
                            stories.map((story, key) => (
                                <SwiperSlide key={`story-${key}`}>
                                    <CardStory data={story} dispatch={dispatch} />
                                </SwiperSlide>
                            ))
                        }
                        </Swiper>
					</div>
				</div>
			</div>
			<div>
				<div className="flex overflow-hidden relative styles_MainHomeTopSlider__C_kzN">
					<div className="relative relative w-full dk-main-slider">
						<div>
							<Swiper
								className="hideNextPrev"
		                        modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
		                        slidesPerView="auto"
		                        pagination={{clickable: true}}
		                        loop={true}
		                        autoplay={{
		                            delay: 3000,       // هر چند میلی‌ثانیه یک‌بار اسلاید عوض شود
		                            disableOnInteraction: false,  // اگر کاربر اسلاید را لمس کند، autoplay متوقف نشود
		                        }}
		                        navigation
		                        style={{ width: "100%" }}
		                        spaceBetween={0} >
							{
								mainSlider.map((slide, key) => (
									<SwiperSlide key={`main-slide-${key}`}>
                                        <div className="">
											<a className="block h-full w-full styles_MainHomeTopSliderItem__widget__lAr4S" target="_blank"  href={slide.url !== null && slide.url !== "" ? slide.url : '#'} onClick={(e) => {if(e.currentTarget.getAttribute('href') === '#'){e.preventDefault();}}}>
												<div>
													<div className="user-select-none absolute z-1 top-0 w-full h-full styles_MainHomeTopSliderItem__image__d1__d" style={{borderRadius: '0px', lineHeight: '0'}}>
														<picture>
															<LazyLoadImage className="w-full h-full inline-block" src={slide.image} alt="" title={slide.title} style={{objectFit: 'cover', borderRadius: '0px'}} />
														</picture>
													</div>
												</div>
											</a>
										</div>
                                    </SwiperSlide>
								))
							}
							</Swiper>
						</div>
					</div>
				</div>
			</div>


			{/*
			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="w-full lg:py-2 bg-neutral-000 lg:items-start flex-wrap lg:justify-around flex overflow-x-auto flex-nowrap overflow-y-hidden hide-scrollbar">
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="سوپرمارکت کوچی" target="_self" href="/#supermarkets">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={SupperMarket} width="52" height="52" alt="سوپرمارکت کوچی" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">سوپرمارکت کوچی</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="تخفیف موبایل‌کارکرده" target="_blank" href="#!">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={TakhfifMobileKarkarde} width="52" height="52" alt="تخفیف موبایل‌کارکرده" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">تخفیف موبایل‌کارکرده</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="طلای‌دیجیتال جایزه‌۵۰برابری" target="_blank" href="#!">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={TalaDigiJayze50} width="52" height="52" alt="طلای‌دیجیتال جایزه‌۵۰برابری" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">طلای‌دیجیتال جایزه‌۵۰برابری</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="دانلود اپ" target="_blank" href="/landings/new-app/">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={DownloadApp} width="52" height="52" alt="دانلود اپ" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">دانلود اپ</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="اشتراک پلاس" target="_blank" href="/plus/landing/">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={EshterakPlus} width="52" height="52" alt="اشتراک پلاس" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">اشتراک پلاس</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="ارسال‌فوری‌ کالای‌دیجیتال" target="_blank" href="/landing/lastsales-itce/">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={ErsalFowriKalaDigi} width="52" height="52" alt="ارسال‌فوری‌ کالای‌دیجیتال" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">ارسال‌فوری‌ کالای‌دیجیتال</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="تخفیف بومی‌محلی" target="_blank" href="/landing/esfand1403-Boomi/">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={TakhfifBoomiMahali} width="52" height="52" alt="تخفیف بومی‌محلی" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">تخفیف بومی‌محلی</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="۴ قسطه" target="_blank" href="/my-digipay/?inapp=1&amp;hideShare=1&amp;action=416">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={FourGhest} width="52" height="52" alt="۴ قسطه" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">۴ قسطه</span>
					</a>
					<a className="flex flex-col items-center user-select-none my-2 lg:my-0 lg:w-35 w-1/8 shrink-0 lg:!w-[82px] w-[75px]" data-cro-id="عیدانه فروشگاه‌حضوری" target="_blank" href="/landing/DKStore/">
						<div style={{width: '52px', height: '52px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={EydaneForooshHozuri} width="52" height="52" alt="عیدانه فروشگاه‌حضوری" title="" style={{objectFit: 'contain'}} />
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1 text-center px-3 lg:px-4">عیدانه فروشگاه‌حضوری</span>
					</a>
					<div data-cro-id="hp-more-ventures" className="shrink-0 w-[80px] flex flex-col items-center user-select-none my-2 lg:my-0 cursor-pointer lg:w-35 w-1/8 px-3 lg:px-4 lg:w-[82px]">
						<div className="bg-neutral-100 rounded-circle flex justify-center items-center text-neutral-400 styles_MainHomeDeepLinks__moreButton__4E_IX">
							<div className="flex">
								<MoreHorizIcon sx={{width: '32px', height: '32px', fill: 'var(--color-icon-low-emphasis)'}} />
							</div>
						</div>
						<span className="text-caption-strong text-neutral-700 mt-1">بیشتر</span>
					</div>
				</div>
			</div>
			*/}



			{ 
				amazingOffers.map((amazingOffer, key) => {
					const timeLeft = timers[key] || {
		            	hours: 0,
			            minutes: 0,
			            seconds: 0,
		          	};
                    if(amazingOffer.products.length > 0)
    					return (
    						<div key={`amazing-offers-${key}`} className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
    							<div className="lg:block flex flex-col justify-center items-center lg:rounded-lg overflow-hidden styles_AmazingCarousel__LvEpp">
    								<div className="w-full flex flex-nowrap pb-5 lg:py-5 lg:pr-0 justify-stretch overflow-hidden relative lg:rounded-large pr-5 lg:pr-0">
    									<Swiper 
                                            className="hideNextPrev"
    										modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
    			                            slidesPerView="auto"
    			                            pagination={{clickable: true}}
    			                            loop={false}
    			                            navigation
    			                            style={{ width: "100%" }}>
    										<SwiperSlide style={{width: 'auto', height: 'auto', marginLeft: '2px'}}>
    			                                <Link className="lg:w-auto w-full lg:h-full flex items-between lg:items-center justify-between flex-row lg:flex-col gap-3 px-5 lg:px-0 pt-5 pb-3 lg:!py-0 !px-4 !mx-5" to={`/amazing-offers`}>
    												<div className="flex flex-row justify-center items-center lg:flex-col gap-2 lg:gap-3">
    													<div className="order-2 lg:order-1" style={{width: '88px', height: '88px', lineHeight: '0'}}>
    														<img className="w-full inline-block" src={Amazings} width="88" height="88" alt="شگفت انگیز" title="" style={{objectFit: 'contain'}} />
    													</div>
    													<div className="flex gap-[2px] items-center right-0 h-6 order-3 lg:order-2">
    														<div className="flex flex-col items-center justify-center bg-white w-[26px] h-[26px] rounded-sm">
    															<div className="flex justify-center items-center text-subtitle-strong text-neutral-800 text-center w-[20px] h-[20px]">
    																{toPersianDigits(timeLeft.seconds)}
    															</div>
    														</div>
    														<div className="text-subtitle-strong text-white w-1">:
    														</div>
    														<div className="flex flex-col items-center justify-center bg-white w-[26px] h-[26px] rounded-sm">
    															<div className="flex justify-center items-center text-subtitle-strong text-neutral-800 text-center w-[20px] h-[20px]">
    																{toPersianDigits(timeLeft.minutes)}
    															</div>
    														</div>
    														<div className="text-subtitle-strong text-white w-1">:
    														</div>
    														<div className="flex flex-col items-center justify-center bg-white w-[26px] h-[26px] rounded-sm">
    															<div className="flex justify-center items-center text-subtitle-strong text-neutral-800 text-center w-[20px] h-[20px]">
    																{toPersianDigits(timeLeft.hours)}
    															</div>
    														</div>
    													</div>
    													<div className="order-1 lg:order-3" style={{width: '80px', height: '80px', lineHeight: '0'}}>
    														<img className="w-full inline-block" src={Amazing} width="80" height="80" alt="شگفت انگیز" title="" style={{objectFit: 'contain'}} />
    													</div>
    												</div>
    												<div className="flex justify-center items-center text-button-2 text-white" data-cro-id="hp-amazing-see-all">مشاهده همه
    													<div className="flex">
    														<ChevronLeftIcon sx={{width: '18px', height: '18px', fill: 'var(--color-icon-white)'}} />
    													</div>
    												</div>
    											</Link>
    			                            </SwiperSlide>
    			                            {
    			                            	amazingOffer.products.map((product, productKey) => {
    			                            		return (
    			                            			<SwiperSlide key={`amazing-offers-${key}-${productKey}`} style={{width: 'auto', height: 'auto', marginLeft: '2px'}}>
    				                                    	<Link className={`block cursor-pointer relative bg-neutral-000 overflow-hidden grow py-2 px-2 lg:px-2 h-full shrink-0 ml-[2px] !h-[auto] lg:!h-full ${productKey === 0 ? 'rounded-r-md' : ''}`}  to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} style={{width: '160px', minWidth: '160px', maxWidth: '160px'}}>
    															<div data-testid="product-card" className="h-full">
    																<article className="overflow-hidden flex flex-col items-stretch justify-start h-full">
    																	<div className="flex grow relative flex-col gap-2">
    																		<div>
    																			<div className="flex items-stretch flex-col relative">
    																				<div className="flex items-start mx-auto">
    																					<div>
    																						<div style={{width: '132px', 'height': '132px', lineHeight: '0'}}>
    																							<picture>
    																								<LazyLoadImage className="w-full rounded-medium inline-block" src={IMAGE_ADDRESS + product.image} alt={product.title} title="" style={{objectFit: 'contain'}} />
    																							</picture>
    																						</div>
    																					</div>
    																				</div>
    																			</div>
    																		</div>
    																		<div className="grow flex flex-col items-stretch justify-start gap-2">
    																			<div>
    																				<h3 className="ellipsis-2 text-body-1 lg:text-body-2 text-neutral-600 h-[40px] !leading-[20px]">{product.title}</h3>
    																			</div>
    																			<div className="pt-1 flex flex-col items-stretch justify-between !pt-0">
    																				<div className="flex items-center justify-between">
    																					<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
    																						<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discountPercentage)}</span>
    																					</div>
    																					<div className="flex items-center justify-end gap-1 text-neutral-700  text-h5 grow text-h5 lg:text-[14px] !leading-[18px] lg:!leading-[24px]">
    																						<span data-testid="price-final">{toPersianDigits(product.discountedPrice)}</span>
    																						<div className="flex">
    																							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}} >
    																								<use xlinkHref="#toman"></use>
    																							</svg>
    																						</div>
    																					</div>
    																				</div>
    																				<div className="flex items-center justify-between pl-5">
    																					<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2 !leading-[15px] lg:!leading-[21px]">{toPersianDigits(product.originalPrice)}
    																					</div>
    																				</div>
    																			</div>
    																		</div>
    																	</div>
    																</article>
    															</div>
    														</Link>
    				                                    </SwiperSlide>
    			                        			);
    			                            	})
    			                            }
    				                        <SwiperSlide key={`amazing-offers-${key}-sell-all`} style={{width: 'auto', height: 'auto', marginLeft: '2px'}}>
                                                <div className="pl-5 lg:h-full">
                                                    <div className="bg-neutral-000 flex flex-col items-center justify-center px-8 rounded-l-md h-full" style={{width: '160px', minWidth: '160px', maxWidth: '160px'}}>
                                                        <Link className="flex flex-col items-center justify-center" to={`/amazing-offers`}>
                                                            <div className="rounded-circle p-2 border-solid border-2 !border-secondary-500">
                                                                <div className="flex">
                                                                    <svg style={{width: '32px', height: '32px', fill: 'var(--color-icon-secondary)'}}>
                                                                        <use xlinkHref="#arrowLeft" />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                            <p className="text-neutral-700 mt-3 text-body-1">مشاهده همه</p>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </SwiperSlide>         
    									</Swiper>
    								</div>
    							</div>
    						</div>
    					);
				})
			}




			{
				adsFourImages.map((adsFourImage, key) => (
					<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0 px-5" key={`ads-banner-four-image-${key}`}>
						<div className="flex flex-wrap">
							{
								adsFourImage.map((adsImage, adsKey) => (
									<CardAdsBannerFourImg data={adsImage} key={`ads-four-image-${key}-${adsKey}`} index={adsKey} />
								))
							}
						</div>
					</div>
				))
			}
			

			{/*	
			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0 px-5">
				<div>
					<a className="relative overflow-hidden bg-neutral-100 user-select-none w-full flex flex-col lg:flex-row justify-between rounded-large lg:items-center px-5 lg:px-10 pt-4 pb-3 styles_AmazingShortcut__main__EbBRH" target="_blank" href="#!">
						<div className="absolute left-0 top-0 bottom-0 right-0 z-1" style={{background: `url(${FreshPattenrSvg}) left center no-repeat`}}>
						</div>
						<div className="absolute right-0 top-0 bottom-0 left-0 rounded-large styles_AmazingShortcut__gradient__dkw_x styles_AmazingShortcut__gradient--fresh__hwLvi">
						</div>
						<div className="flex flex-col lg:flex-row items-start lg:items-center z-1 shrink-0 gap-2 lg:gap-0">
							<div className="flex items-center z-1 shrink-0">
								<div style={{width: '66px', height: '62px', lineHeight: '0'}}>
									<picture>
										<source type="image/webp" srcSet={FreshWebp} />
										<source type="image/jpeg" srcSet={FreshWebp} />
										<img className="w-full inline-block" src={FreshWebp} width="66" height="62" alt="icon" title="" style={{objectFit: 'contain'}} />
									</picture>
								</div>
								<div className="mx-2 lg:mx-5" style={{width: '250px', height: '28px', lineHeight: '0'}}>
									<img className="w-full inline-block" src={FreshIncredibleOfferSvg} width="250" height="28" alt="" title="" style={{objectFit: 'contain'}} />
								</div>
							</div>
							<div className="inline-flex items-center text-neutral-000 text-center mx-2 lg:mx-0 flex justify-center text-normal bg-fresh-700 styles_AmazingShortcut__badge__eIFZL Badge_Badge__QIekq Badge_Badge--medium__fP85d px-3 text-body2-strong" style={{color: ' var(--color-undefined)'}}><p className="inline-block  text-body1-strong text-white">تا ۵۵٪ تخفیف</p>
							</div>
						</div>
						<div className="flex items-center justify-between lg:justify-start mt-4 lg:mt-0 lg:mr-4 z-1">
							<div className="flex items-center lg:justify-end flex-nowrap lg:flex-wrap overflow-hidden styles_AmazingShortcut__productItems__B6LWb">
								<Link className="relative bg-neutral-000 rounded-circle flex items-center justify-center p-2 ml-2 lg:mb-4" to="../product">
									<div className="overflow-hidden rounded-circle">
										<div style={{width: '58px', height: '58px', lineHeight: '0'}}>
											<picture>
												<source type="image/webp" srcSet={FreshProduct1} />
												<source type="image/jpeg" srcSet={FreshProduct1} />
												<img className="w-full inline-block" src={FreshProduct1} width="58" height="58" alt="عسل کوهستان شیگوار - 1.8 کیلوگرم" title="" style={{objectFit: 'contain'}} />
											</picture>
										</div>
									</div>
									<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error absolute right-0 bottom-0 z-1"><span className="text-body2-strong" data-testid="price-discount-percent">۵۵٪</span>
									</div>
								</Link>
								<Link className="relative bg-neutral-000 rounded-circle flex items-center justify-center p-2 ml-2 lg:mb-4" to="../product">
									<div className="overflow-hidden rounded-circle">
										<div style={{width: '58px', height: '58px', lineHeight: '0'}}>
											<picture>
											<source type="image/webp" srcSet={FreshProduct2} />
											<source type="image/jpeg" srcSet={FreshProduct2} />
											<img className="w-full inline-block" src={FreshProduct2} width="58" height="58" alt="نوشابه انرژی گاز دار لایف استار -&nbsp;250 میلی لیتر بسته 6 عددی" title="" style={{objectFit: 'contain'}} />
											</picture>
										</div>
									</div>
									<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error absolute right-0 bottom-0 z-1"><span className="text-body2-strong" data-testid="price-discount-percent">۴۰٪</span>
									</div>
								</Link>
								<Link className="relative bg-neutral-000 rounded-circle flex items-center justify-center p-2 ml-2 lg:mb-4" to="../product">
									<div className="overflow-hidden rounded-circle">
										<div style={{width: '58px', height: '58px', lineHeight: '0'}}>
											<picture>
												<source type="image/webp" srcSet={FreshProduct3} />
												<source type="image/jpeg" srcSet={FreshProduct3} />
												<img className="w-full inline-block" src={FreshProduct3} width="58" height="58" alt="پنیر پیتزا موزارلا شه وین - 2 کیلوگرم" title="" style={{objectFit: 'contain'}} />
											</picture>
										</div>
									</div>
									<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error absolute right-0 bottom-0 z-1"><span className="text-body2-strong" data-testid="price-discount-percent">۴۰٪</span>
									</div>
								</Link>
								<Link className="relative bg-neutral-000 rounded-circle flex items-center justify-center p-2 ml-2 lg:mb-4" to="../product">
									<div className="overflow-hidden rounded-circle">
										<div style={{width: '58px', height: '58px', lineHeight: '0'}}>
											<picture>
												<source type="image/webp" srcSet={FreshProduct4} />
												<source type="image/jpeg" srcSet={FreshProduct4} />
												<img className="w-full inline-block" src={FreshProduct4} width="58" height="58" alt="هل سبز مصطفوی - 10 گرم" title="" style={{objectFit: 'contain'}} />
											</picture>
										</div>
									</div>
									<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error absolute right-0 bottom-0 z-1"><span className="text-body2-strong" data-testid="price-discount-percent">۳۹٪</span>
									</div>
								</Link>
								<Link className="relative bg-neutral-000 rounded-circle flex items-center justify-center p-2 ml-2 lg:mb-4" to="../product">
									<div className="overflow-hidden rounded-circle">
										<div style={{width: '58px', height: '58px', lineHeight: '0'}}>
											<picture>
												<source type="image/webp" srcSet={FreshProduct5} />
												<source type="image/jpeg" srcSet={FreshProduct5} />
												<img className="w-full inline-block" src={FreshProduct5} width="58" height="58" alt="رشته آش سنتی رشد مقدار 500 گرم" title="" style={{objectFit: 'contain'}} />
											</picture>
										</div>
									</div>
									<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error absolute right-0 bottom-0 z-1"><span className="text-body2-strong" data-testid="price-discount-percent">۳۶٪</span>
									</div>
								</Link>
								<Link className="relative bg-neutral-000 rounded-circle flex items-center justify-center p-2 ml-2 lg:mb-4" to="../product">
									<div className="overflow-hidden rounded-circle">
										<div style={{width: '58px', height: '58px', lineHeight: '0'}}>
											<picture>
												<source type="image/webp" srcSet={FreshProduct6} />
												<source type="image/jpeg" srcSet={FreshProduct6} />
												<img className="w-full inline-block" src={FreshProduct6} width="58" height="58" alt="عصاره مرغ الیت بسته 48 عددی" title="" style={{objectFit: 'contain'}} />
											</picture>
										</div>
									</div>
									<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error absolute right-0 bottom-0 z-1"><span className="text-body2-strong" data-testid="price-discount-percent">۳۵٪</span>
									</div>
								</Link>
							</div>
							<div className="bg-neutral-000 p-3 lg:py-3 lg:px-5 text-button-2 flex items-center justify-center text-fresh-700 styles_AmazingShortcut__button__DU7l4"><span className="hidden lg:inline whitespace-nowrap cursor-pointer">بیش از ۱۰۰ کالا</span>
								<div className="flex mr-0 lg:mr-2">
									<ArrowBackIcon sx={{width: '20px', height: '20px', fill: 'var(--color-fresh-700)'}} />
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>
			*/}


			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="w-full py-3 lg:pt-4 lg:pb-10 flex flex-col items-center">
					<div className="mb-6 lg:mb-9 text-center">
						<h3 className="text-h3">خرید بر اساس دسته‌بندی</h3>
					</div>
					<div className="relative relative w-full dk-main-slider">
						<div>
							<Swiper
                                className="hideNextPrev"
								{...buyByCategoriesSwiper}
								modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                                pagination={{clickable: true}}
                                loop={false}
                                navigation >
                                {
	                                categories.map((cat, key) => {
	                                	if(key === 0 || key % 2 === 0) 
		                             		return (
		                             			<SwiperSlide key={`buy-by-cat-${key}`} style={{width: 'auto', height: 'auto'}}>
		                             				<div className="flex flex-col items-center justify-between gap-2">
														<span data-cro-id="hp-categories-icons" className="h-40 px-4">
															<a className="flex flex-col items-center user-select-none w-full lg:p-0 lg:mx-0" href={cat.url}>
																<div className="flex items-center justify-center" style={{width: '100px', height: '100px', lineHeight: 0}}>
																	<LazyLoadImage className="w-full h-full inline-block" src={cat.megaMenu} width="100" height="100" alt={cat.title} title="" style={{objectFit: 'contain'}} />
																</div>
																<p className="text-body2-strong text-neutral-900 mt-2 text-center ellipsis-2">{cat.title}</p>
															</a>
														</span>
														{categories[key + 1] !== undefined ?
														<span data-cro-id="hp-categories-icons" className="h-40 px-4">
															<a className="flex flex-col items-center user-select-none w-full lg:p-0 lg:mx-0" href={cat.url}>
																<div className="flex items-center justify-center" style={{width: '100px', height: '100px', lineHeight: 0}}>
																	<LazyLoadImage className="w-full h-full inline-block" src={categories[key+1].megaMenu} width="100" height="100" alt={categories[key+1].title} title="" style={{objectFit: 'contain'}} />
																</div>
																<p className="text-body2-strong text-neutral-900 mt-2 text-center ellipsis-2">{categories[key+1].title}</p>
															</a>
														</span>
														:''}
													</div>
		                             			</SwiperSlide>
		                             		);	
	                                })
                                }
							</Swiper>
						</div>
					</div>
				</div>
			</div>


			{
				adsTwoImages.map((adsTwoImage, key) => (
					<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0 px-5" key={`ads-banner-two-image-${key}`}>
						<div className="flex flex-wrap">
							{
								adsTwoImage.map((adsImage, imageKey) => (
									<CardAdsBannerTwoImg data={adsImage} key={`ads-two-image-${key}-${imageKey}`} index={imageKey} />
								))
							}
						</div>
					</div>
				))
			}
			
			{/*<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="w-full py-6 bg-neutral-000 lg:rounded-large lg:border-complete-200 ">
					<div className="flex justify-center items-center">
						<div className="flex ml-2">
							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-rating-0-2)'}} >
								<use xlinkHref="#topBrands"></use>
							</svg>
						</div>
						<p className="text-h3 text-neutral-900">محبوب‌ترین برندها</p>
					</div>
					<div className="mt-3 overflow-hidden w-full">
						<div>
							<Swiper
                                className="hideNextPrev"
								modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                                slidesPerView="auto"
                                pagination={{clickable: true}}
                                loop={false}
                                navigation
                                style={{ width: "100%" }}>
								{
									brands.map((brand, key) => {
										return (
											<SwiperSlide className="br-list-horizontal-0" style={{width: 'auto', height: 'auto'}} >
												<a className="px-4 py-1 overflow-hidden flex items-center justify-center h-full shrink-0 br-list-horizontal-0" data-cro-id="hp-favorited-barnds" href="#!">
													<div className="flex items-center justify-center" style={{width: '110px', height: '110px', lineHeight: '0'}}>
														<img className="w-full inline-block" src={brand.image} width="110" height="110" alt={brand.title} title="" style={{objectFit: 'contain'}} />
													</div>
												</a>
											</SwiperSlide>
										);
									})
								}
							</Swiper>
						</div>
					</div>
				</div>
			</div>*/}

            <div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
                <div className="w-full py-3 lg:pt-4 lg:pb-10 flex flex-col items-center">
                    <div className="mb-6 lg:mb-9 text-center">
                        <h3 className="text-h3">فروشگاه ها</h3>
                    </div>
                    <div className="relative relative w-full dk-main-slider">
                        <div>
                            <Swiper
                                className="hideNextPrev"
                                {...buyByCategoriesSwiper}
                                modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                                pagination={{clickable: true}}
                                loop={false}
                                navigation >
                                {
                                    sellers.map((seller, key) => {
                                            return (
                                                <SwiperSlide key={`seller-${key}`} style={{width: 'auto', height: 'auto'}}>
                                                    <div className="flex flex-col items-center justify-between gap-2">
                                                        <span data-cro-id="hp-categories-icons" className="h-40 px-4">
                                                            <Link className="flex flex-col items-center user-select-none w-full lg:p-0 lg:mx-0" to={`seller/${seller.sellerCode}`}>
                                                                <div className="flex items-center justify-center" style={{width: '100px', height: '100px', lineHeight: 0}}>
                                                                    <LazyLoadImage className="w-full h-full inline-block" src={IMAGE_ADDRESS +  seller.logo} width="100" height="100" alt={seller.title} title="" style={{objectFit: 'contain'}} />
                                                                </div>
                                                                <p className="text-body2-strong text-neutral-900 mt-2 text-center ellipsis-2">{seller.title}</p>
                                                            </Link>
                                                        </span>
                                                    </div>
                                                </SwiperSlide>
                                            );  
                                    })
                                }

                                <SwiperSlide key={`seller-see-all`} style={{width: 'auto', height: 'auto'}}>
                                    <div className="flex flex-col items-center justify-center px-10 h-full">
                                        <button onClick={() => navigate(`/sellers`)} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--outlined__saFC3 styles_btn--black__xj6Mt styles_btn--icon__7ZUM7 rounded-circle p-2">
                                            <div className="flex items-center justify-center relative grow">
                                                <div className="flex">
                                                    <svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-black)'}}>
                                                        <use xlinkHref="#arrowLeft"></use>
                                                    </svg>
                                                </div>
                                            </div>
                                        </button>
                                        <span className="whitespace-nowrap mt-2 text-caption-strong">مشاهده همه
                                        </span>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>



			{ tasteful1.length > 0 &&
			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="lazyload-wrapper ">
					<div>
						<div className="grid bg-neutral-100 grid-cols-1 lg:rounded-large lg:border-complete-200 overflow-hidden lg:grid-cols-4 styles_WidgetYogaBar__XMRUT">
							{ 
								tasteful1.map((tasteful, key) => (
									<div key={`tasteful1-${key}`} className="flex flex-col w-full h-full px-5 py-2 bg-neutral-000">
										<div className="flex items-center">
											<div className="flex flex-col mb-2 w-full">
												<div className="w-full flex items-center justify-between">
													<div className="flex items-center">
														<div className="user-select-none">
														</div>
														<h4 className="text-h5 text-neutral-800">{tasteful.categoryTitle}</h4>
													</div>
												</div>
												<p className="text-caption text-neutral-500">بر اساس سلیقه شما</p>
											</div>
										</div>
										<div className="grid bg-neutral-100 min-h-62 grid-cols-2 styles_WidgetYoga__content__ngfUV flex-1">
											{
												tasteful.products.map((product, productKey) => (
													<Link className="w-full flex items-center bg-neutral-000 justify-center p-2 relative" to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
														<span className="flex items-center rounded lg:roundehidden h-full">
															<div className="h-full" style={{lineHeight: '0'}}>
																<LazyLoadImage className="w-full w-full ratio-1-1 inline-block" src={IMAGE_ADDRESS + product.image} alt={product.title} title="" style={{objectFit: 'contain'}} />
															</div>
														</span>
													</Link>
												))
											}
										</div>
										<div className="flex items-center justify-center mt-1 mb-3">
											<Link className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2" to={`/category/${tasteful.catUrl}`}>
												<span>مشاهده
												</span>
												<div className="flex">
													<ChevronLeftIcon style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}} />
												</div>
											</Link>
										</div>
									</div>
								))
							}
						</div>
					</div>
				</div>
			</div>
			}

			{ bestSelling.length > 0 &&
			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="w-full flex flex-col justify-center align-items py-4 bg-neutral-000 lg:rounded-large lg:border-complete-200">
					<div className="flex justify-between lg:justify-center items-center px-2 lg:px-5 relative">
						<div className="flex justify-center items-center">
							<div className="flex ml-2">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
									<use xlinkHref="#searchTrend"></use>
								</svg>
							</div>
							<p className="text-h3 text-neutral-900">پرفروش‌ترین کالاها</p>
						</div>
						<a className="styles_Link__RMyqc" href="#!">
							<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--text__W2jhM styles_btn--secondary__Warw0 rounded-medium lg:absolute left-0 top-0 pl-4 shrink-0">
								<div className="flex items-center justify-center relative grow">مشاهده همه
								</div>
							</button>
						</a>
					</div>
					<div className="px-2 mt-5 lg:mt-7 gap-4 gap-y-0 lg:gap-0">
						<Swiper
							className="hideNextPrev"
							modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                            slidesPerView="auto"
                            pagination={{clickable: true}}
                            loop={false}
                            navigation
                            style={{ width: "100%" }}
                            spaceBetween={20} >
                            {
                            	bestSelling.map((product, key) => {
                            		if(key === 0 || key % 3 === 0) 
                                		return (
                                			<SwiperSlide key={`best-selling-${key}`} style={{width: '314.5px', height: 'auto'}}>
                                				<div>
													<Link className="flex styles_ProductItem__Ue_Ty" to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`}>
														<div className="flex styles_ProductItem__Ue_Ty">
															<div className="rounded shrink-0 ml-3" style={{width: '86px', height: '86px', lineHeight: '0'}}>
																<picture>
																	<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + product.image} width="86" height="86" alt={product.title} title="" style={{objectFit: 'contain'}} />
																</picture>
															</div>
															<span className="text-secondary-500 text-h2-extra ml-3 flex items-center">{toPersianDigits(key + 1)}
															</span>
															<div className="grow flex flex-col justify-center relative styles_ProductItem__description__jESgJ">
																<p className="text-body-2 text-neutral-700 ellipsis-2 overflow-hidden">{product.title}</p>
															</div>
														</div>
													</Link>
													{bestSelling[key + 1] !== undefined ?
													<Link className="flex styles_ProductItem__Ue_Ty" to={`/product/${bestSelling[key + 1].slug}/${bestSelling[key + 1].title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`}>
														<div className="flex styles_ProductItem__Ue_Ty">
															<div className="rounded shrink-0 ml-3" style={{width: '86px', height: '86px', lineHeight: '0'}}>
																<picture>
																	<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + bestSelling[key + 1].image} width="86" height="86" alt={bestSelling[key + 1].title} title="" style={{objectFit: 'contain'}} />
																</picture>
															</div>
															<span className="text-secondary-500 text-h2-extra ml-3 flex items-center">{toPersianDigits(key + 2)}
															</span>
															<div className="grow flex flex-col justify-center relative styles_ProductItem__description__jESgJ">
																<p className="text-body-2 text-neutral-700 ellipsis-2 overflow-hidden">{bestSelling[key + 1].title}</p>
															</div>
														</div>
													</Link>
													:''}
													{bestSelling[key + 2] !== undefined ?
													<Link className="flex styles_ProductItem__Ue_Ty" to={`/product/${bestSelling[key + 2].slug}/${bestSelling[key + 2].title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`}>
														<div className="flex styles_ProductItem__Ue_Ty">
															<div className="rounded shrink-0 ml-3" style={{width: '86px', height: '86px', lineHeight: '0'}}>
																<picture>
																	<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + bestSelling[key + 2].image} width="86" height="86" alt={bestSelling[key + 2].title} title="" style={{objectFit: 'contain'}} />
																</picture>
															</div>
															<span className="text-secondary-500 text-h2-extra ml-3 flex items-center">{toPersianDigits(key + 3)}
															</span>
															<div className="grow flex flex-col justify-center relative styles_ProductItem__description__jESgJ">
																<p className="text-body-2 text-neutral-700 ellipsis-2 overflow-hidden">{bestSelling[key + 2].title}</p>
															</div>
														</div>
													</Link>
													:''}
												</div>
                                			</SwiperSlide>
                            			);
                            	})
                            }
						</Swiper>
					</div>
				</div>
			</div>
			}

			{ tasteful2.length > 0 &&
			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="lazyload-wrapper ">
					<div>
						<div className="grid bg-neutral-100 grid-cols-1 lg:rounded-large lg:border-complete-200 overflow-hidden lg:grid-cols-4 styles_WidgetYogaBar__XMRUT">
							{ 
								tasteful2.map((tasteful, key) => (
									<div key={`tasteful-2-${key}`} className="flex flex-col w-full h-full px-5 py-2 bg-neutral-000">
										<div className="flex items-center">
											<div className="flex flex-col mb-2 w-full">
												<div className="w-full flex items-center justify-between">
													<div className="flex items-center">
														<div className="user-select-none">
														</div>
														<h4 className="text-h5 text-neutral-800">ساعت هوشمند</h4>
													</div>
												</div>
												<p className="text-caption text-neutral-500">بر اساس سلیقه شما</p>
											</div>
										</div>
										<div className="grid bg-neutral-100 min-h-62 grid-cols-2 styles_WidgetYoga__content__ngfUV flex-1">
											{
												tasteful.products.map((product, productKey) => (
													<Link className="w-full flex items-center bg-neutral-000 justify-center p-2 relative" to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
														<span className="flex items-center rounded lg:roundehidden h-full">
															<div className="h-full" style={{lineHeight: '0'}}>
																<LazyLoadImage className="w-full w-full ratio-1-1 inline-block" src={IMAGE_ADDRESS + product.image} alt={product.title} title="" style={{objectFit: 'contain'}} />
															</div>
														</span>
													</Link>
												))
											}
										</div>
										<div className="flex items-center justify-center mt-1 mb-3">
											<Link className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2" to={`/category/${tasteful.catUrl}`}>
												<span>مشاهده
												</span>
												<div className="flex">
													<ChevronLeftIcon style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}} />
												</div>
											</Link>
										</div>
									</div>
								))
							}
						</div>
					</div>
				</div>
			</div>
			}

			{ featuredDiscounts.length > 0 &&
			<div className="lazyload-wrapper ">
				<div>
					<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
						<div className="px-5 lg:px-3  bg-neutral-000 lg:rounded-large lg:border-complete-200">
							<div className="flex items-center justify-center py-3 lg:py-4 mb-2">
								<div className="flex">
									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-primary)'}}>
										<use xlinkHref="#discount"></use>
									</svg>
								</div>
								<h3 className="mr-2 text-h3">منتخب محصولات تخفیف و حراج</h3>
							</div>
							<div className="grid grid-cols-2 lg:grid-cols-5 xl:grid-cols-6 styles_WidgetPromotionalGrid__items__AOK7m">
							{
								featuredDiscounts.map((kala, key) => {
									return (
										<Link key={`featuredDiscounts-${key}`} className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow py-3 px-4 lg:px-2 h-full" to={`/product/${kala.slug}/${kala.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
											<div data-testid="product-card" className="h-full">
												<article className="overflow-hidden flex flex-col items-stretch justify-start h-full">
													<div className="flex grow relative flex-col">
														<div className="">
															<div className="flex items-stretch flex-col relative mb-1">
																<div className="flex items-start mx-auto">
																	<div>
																		<div className="flex items-center justify-start gap-1 flex-wrap absolute top-0 right-0 z-1 style_ProductImage__miniBadges__uxcGX"><br /><br />
																		</div>
																		<div style={{width: '150px', height: '150px', lineHeight: '0'}}>
																			<picture>
																				<LazyLoadImage className="w-full rounded-medium inline-block" src={IMAGE_ADDRESS + kala.image} width="150" height="150" alt={kala.title} title="" style={{objectFit: 'contain'}} />
																			</picture>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="grow flex flex-col items-stretch justify-start">
															<div className="pt-1 flex flex-col items-stretch justify-between">
																<div className="flex items-center justify-between">
																	<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
																		<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(kala.discountPercentage)}</span>
																	</div>
																	<div className="flex items-center justify-end gap-1 text-neutral-700 text-neutral-400 text-h5 grow">
																		<span data-testid="price-final">{toPersianDigits(kala.discountedPrice)}</span>
																		<div className="flex">
																			<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
																				<use xlinkHref="#toman"></use>
																			</svg>
																		</div>
																	</div>
																</div>
																<div className="flex items-center justify-between pl-5">
																	<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">{toPersianDigits(kala.originalPrice)}
																	</div>
																</div>
															</div>
															{ kala.timer !== undefined && kala.timer !== '' ?
															<div className="mt-auto">
																<div>
																	<div className="relative bg-neutral-100 invisible style_ProductPromotionTimeline__progress__JnKWE">
																		<div className="absolute bg-primary-700 h-full left-0 top-0 style_ProductPromotionTimeline--active__oYyta">
																		</div>
																	</div>
																	<div className="whitespace-nowrap flex justify-between pt-1">
																		<div className="invisible">
																			<span className="text-primary-700 text-body-strong ml-1">%</span>
																			<span className="text-neutral-500 text-caption">فروش رفته</span>
																		</div>
																		<div className="text-primary-700 text-body2-strong style_ProductPromotionTimeline__timer__zS6ZA">۵۹ : ۳۷ : ۰۰
																		</div>
																	</div>
																</div>
															</div>
															:''}
														</div>
													</div>
												</article>
											</div>
										</Link>
									);
								})
							}
							</div>
						</div>
					</div>
				</div>
			</div>
			}

			{ hotSales.length > 0 &&
			<div className="container-2xl-w mx-auto lg:px-4 2xl:px-0">
				<div className="w-full flex flex-col justify-center align-items py-4 bg-neutral-000 lg:rounded-large lg:border-complete-200">
					<div className="flex justify-between lg:justify-center items-center px-2 lg:px-5 relative">
						<div className="flex justify-center items-center">
							<div className="flex ml-2">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
									<use xlinkHref="#searchTrend"></use>
								</svg>
							</div>
							<p className="text-h3 text-neutral-900">داغ ترین چند ساعت گذشته</p>
						</div>
					</div>
					<div className="px-2 mt-5 lg:mt-7 gap-4 gap-y-0 lg:gap-0">
						<Swiper
							className="hideNextPrev"
							modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                            slidesPerView="auto"
                            pagination={{clickable: true}}
                            loop={false}
                            navigation
                            style={{ width: "100%" }}
                            spaceBetween={20} >
                            {
                            	hotSales.map((product, key) => {
                            		if(key === 0 || key % 3 === 0) 
                                		return (
                                			<SwiperSlide key={`hot-sales-$key`} style={{width: '314.5px', height: 'auto'}}>
                                				<div>
													<Link className="flex styles_ProductItem__Ue_Ty" to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
														<div className="flex styles_ProductItem__Ue_Ty">
															<div className="rounded shrink-0 ml-3" style={{width: '86px', height: '86px', lineHeight: '0'}}>
																<picture>
																	<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + product.image} width="86" height="86" alt={product.title} title="" style={{objectFit: 'contain'}} />
																</picture>
															</div>
															<span className="text-secondary-500 text-h2-extra ml-3 flex items-center">{toPersianDigits(key + 1)}
															</span>
															<div className="grow flex flex-col justify-center relative styles_ProductItem__description__jESgJ">
																<p className="text-body-2 text-neutral-700 ellipsis-2 overflow-hidden">{product.title}</p>
															</div>
														</div>
													</Link>
													{hotSales[key + 1] !== undefined ?
													<Link className="flex styles_ProductItem__Ue_Ty" to={`/product/${hotSales[key + 1].slug}/${hotSales[key + 1].title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`}>
														<div className="flex styles_ProductItem__Ue_Ty">
															<div className="rounded shrink-0 ml-3" style={{width: '86px', height: '86px', lineHeight: '0'}}>
																<picture>
																	<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + hotSales[key + 1].image} width="86" height="86" alt={hotSales[key + 1].title} title="" style={{objectFit: 'contain'}} />
																</picture>
															</div>
															<span className="text-secondary-500 text-h2-extra ml-3 flex items-center">{toPersianDigits(key + 2)}
															</span>
															<div className="grow flex flex-col justify-center relative styles_ProductItem__description__jESgJ">
																<p className="text-body-2 text-neutral-700 ellipsis-2 overflow-hidden">{hotSales[key + 1].title}</p>
															</div>
														</div>
													</Link>
													:''}
													{hotSales[key + 2] !== undefined ?
													<Link className="flex styles_ProductItem__Ue_Ty" to={`/product/${hotSales[key + 2].slug}/${hotSales[key + 2].title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`}>
														<div className="flex styles_ProductItem__Ue_Ty">
															<div className="rounded shrink-0 ml-3" style={{width: '86px', height: '86px', lineHeight: '0'}}>
																<picture>
																	<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + hotSales[key + 2].image} width="86" height="86" alt={hotSales[key + 2].title} title="" style={{objectFit: 'contain'}} />
																</picture>
															</div>
															<span className="text-secondary-500 text-h2-extra ml-3 flex items-center">{toPersianDigits(key + 3)}
															</span>
															<div className="grow flex flex-col justify-center relative styles_ProductItem__description__jESgJ">
																<p className="text-body-2 text-neutral-700 ellipsis-2 overflow-hidden">{hotSales[key + 2].title}</p>
															</div>
														</div>
													</Link>
													:''}
												</div>
                                			</SwiperSlide>
                            			);
                            	})
                            }
						</Swiper>
					</div>
				</div>
			</div>
			} 

		</div>

    );
}

export default MainBody;